const initials = "entertainment/";
export const UPDATE_ENTERTAINMENT_PRODUCTS = `${initials}UPDATE_ENTERTAINMENT_PRODUCTS`;
